import Vue from "vue";

Vue.directive("lazyload-img", {
    bind(el, binding)
    {
        let imageUrl = el.getAttribute("data-src");

        if (!imageUrl)
        {
            return;
        }

        el.style.opacity = "0";
        el.style.transition = "opacity 0.5s";

        const options = {
            rootMargin: "0px",
            threshold: 0.1
        };

        let observer;

        function loadImage()
        {
            if ("IntersectionObserver" in window && el.offsetParent !== null)
            {
                observer = new IntersectionObserver(function(entries, observer)
                {
                    entries.forEach(function(entry)
                    {
                        if (entry.isIntersecting)
                        {
                            el.src = imageUrl;
                            el.onload = () => el.style.opacity = "1";
                            observer.unobserve(el);
                        }
                    });
                }, options);

                observer.observe(el);
            }
            else
            {
                el.src = imageUrl;
                el.onload = () => el.style.opacity = "1";
            }
        }

        loadImage();

        Vue.nextTick(() =>
        {
            const newImageUrl = el.getAttribute("data-src");

            if (newImageUrl && newImageUrl !== imageUrl)
            {
                imageUrl = newImageUrl;
                loadImage();
            }
        });

        el._observer = observer;
    },

    unbind(el)
    {
        if (el._observer && el._observer.disconnect)
        {
            el._observer.disconnect();
        }
    }
});
